import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const vendorManufacturing = async ({ data = {} }) => {
  const url = API.MANUFACTURING;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const saveAsDraftManufacturing = async ({ data = {} }) => {
  const url = API.SAVE_AS_DRAFT;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const validateBulkManufacturing = async ({ data = {} }) => {
  const url = API.BULK_VALIDATE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const exportBulkManfacture = async ({ data = {} }) => {
  const url = API.EXPORT_MANUFACTURING;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const exportBulkManfactureTemplate = async ({ data = {} }) => {
  const url = API.EXPORT_MANUFACTURING_TEMPLATE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const importBulkManfacture = async ({ data = {} }) => {
  const url = API.IMPORT_MANUFACTURING;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const vendorLot = async ({ data = {} }) => {
  const url = API.LOT_DETAILS;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const batchInfo = async ({ data = {} }) => {
  const url = API.BATCH_LIST;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const updatePriority = async ({ data = {} }) => {
  const url = API.UPDATE_PRIORITY;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const batchCreation = async ({ data = {} }) => {
  const url = API.BATCH_CREATION;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
export const batchQtyUpdate = async ({ data = {} }) => {
  const url = API.QTY_UPDATE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

/**
 * batchUpsert - Single endpoint for creating or updating batches
 * Replaces the need for separate batchCreation and batchQtyUpdate calls
 *
 * - If batch_id present → Updates existing batch
 * - If batch_id absent → Creates new batch
 *
 * Benefits:
 * - Eliminates two-step sewing report workaround
 * - Single API call reduces latency
 * - Atomic operations (all-or-nothing)
 * - Simpler error handling
 */
export const batchUpsert = async ({ data = {} }) => {
  const url = API.BATCH_UPSERT;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const batchDelete = async ({ data = {} }) => {
  const url = API.DELETE_BATCH;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const readyForPack = async ({ data = {} }) => {
  const url = API.READY_TO_PACK;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const productImage = async ({ data = {} }) => {
  const url = API.PRODUCT_IMAGE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const getPrint = async ({ data = {} }) => {
  const url = API.PRINT_LABEL;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const readyForDye = async ({ data = {} }) => {
  const url = API.READY_TO_DYE;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const getPackageList = async ({ data = {} }) => {
  const url = API.BLP_LIST;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const convertTo3Pack = async ({ data = {} }) => {
  const url = API.CONVERT_TO_3PACK;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};
